import React, { Fragment, ReactNode } from 'react';
import { LocalizationService } from 'app/services/localization';

// Stolen from Mnoga
const splitRegex = /(%{[^}]+})/g;
const pickRegex = /^%{([^}]+)}$/;

/**
 * React-aware version of `t` method. Returns a `React.Fragment`
 * instead of a `string` and allows for translation placeholders
 * (`%{...}`) to be any valid React nodes.
 *
 * Example:
 * ```
 * // en.json:
 * {
 *   "go-to-faq": "Check %{link} for if you have any questions",
 *   "faq": "FAQ",
 * }
 *
 * const FaqLink = () =>
 *   tx('go-to-faq', {
 *     link: <Link href="/faq">{tx('faq')}</Link>
 *   });
 * ```
 */
export default function tx(
  localizationService: LocalizationService,
  name: string,
  data: { [x: string]: ReactNode } = {},
) {
  // Pull magic variable out of data if it is valid to do so.
  const count = typeof data.count === 'number' ? data.count : undefined;

  // eslint-disable-next-line @engoo/engoo/literal-string-keys
  const tokens = localizationService.t(name, { count })
    .split(splitRegex)
    .filter((x: string) => x)
    .map((s: string) => {
      const match = s.match(pickRegex);

      if (match) {
        const key = match[1];

        if (key in data) {
          return data[match[1]];
        } else {
          return s;
        }
      } else {
        return s;
      }
    });

  return <Fragment>{tokens.map((token: ReactNode, i: number) =>
    <Fragment key={i}>{token}</Fragment>,
  )}</Fragment>;
}
